import { render, staticRenderFns } from "./GrantWhatsApp.vue?vue&type=template&id=ce2c474a&"
import script from "./GrantWhatsApp.vue?vue&type=script&lang=js&"
export * from "./GrantWhatsApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports